import { render, staticRenderFns } from "./DefaultParameter.vue?vue&type=template&id=f1f5ebe4&scoped=true"
import script from "./DefaultParameter.vue?vue&type=script&lang=js"
export * from "./DefaultParameter.vue?vue&type=script&lang=js"
import style0 from "./DefaultParameter.vue?vue&type=style&index=0&id=f1f5ebe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f5ebe4",
  null
  
)

export default component.exports